import { Button, Modal, NumberInput } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useCreateBankAccountBalance } from 'src/Hooks/Mutations/useCreateBankAccountBalance';

import styles from './RecordBankAccountBalanceModal.module.scss';
import { Props } from './RecordBankAccountBalanceModal.types';

const RecordBankAccountBalanceModal = ({ opened, onClose, bankAccountId }: Props) => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState<number | ''>(0);
  const [recordedAt, setRecordedAt] = useState<Date | null>(new Date());
  const { mutate, isLoading } = useCreateBankAccountBalance({ onSuccess: () => onClose() });

  useEffect(() => {
    if (opened) {
      setAmount(0);
      setRecordedAt(new Date());
    }
  }, [opened]);

  const handleSave = () => {
    if (amount === '' || !recordedAt) return;
    mutate({ bankAccountId, createData: { amount, recordedAt: dayjs(recordedAt) } });
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <div className={styles.title}>
          {t('bankAccounts.balance.modal.title', 'Saisir un solde')}
        </div>
      }
    >
      <div className={styles.content}>
        <NumberInput
          label={t('bankAccounts.balance.modal.amountLabel', 'Montant')}
          value={amount}
          onChange={val => setAmount(val === '' ? '' : Number(val))}
          suffix=" €"
          decimalScale={2}
          thousandSeparator=" "
          className={styles.field}
        />

        <DatePickerInput
          label={t('bankAccounts.balance.modal.dateLabel', 'Date du solde')}
          value={recordedAt}
          onChange={setRecordedAt}
          maxDate={new Date()}
          className={styles.field}
        />
      </div>

      <div className={styles.buttons}>
        <Button variant="outline" onClick={onClose} disabled={isLoading}>
          {t('common.cancel', 'Annuler')}
        </Button>
        <Button onClick={handleSave} loading={isLoading} disabled={amount === '' || !recordedAt}>
          {t('common.save', 'Enregistrer')}
        </Button>
      </div>
    </Modal>
  );
};

export default RecordBankAccountBalanceModal;
